import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface Props {
  to: string;
}

export const RedirectWithSearchParams = ({ to }: Props): JSX.Element => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [toPath, toSearchQuery] = to.split('?');
  // combine search params from current location and the redirect target
  // target query params will override current query params
  const toSearchParams = new URLSearchParams(toSearchQuery ?? '');
  const combinedSearchParams = new URLSearchParams();
  searchParams.forEach((value, key) => combinedSearchParams.set(key, value));
  toSearchParams.forEach((value, key) => combinedSearchParams.set(key, value));

  return <Navigate to={`${toPath}?${combinedSearchParams}`} />;
};
